document.addEventListener('DOMContentLoaded', () => {
  console.log('[CIG] DOM ready');

  const sections = document.querySelectorAll('section.hafa-cig');
  console.log('[CIG] sections found:', sections.length);

  if (!sections.length) return;

  sections.forEach((section, sectionIndex) => {
    console.log(`[CIG] init section ${sectionIndex}`);

    const modal = section.querySelector('[data-cig-modal]');
    const imgEl = section.querySelector('[data-cig-img]');
    const openBtns = Array.from(section.querySelectorAll('[data-cig-open]'))
      .filter(btn => btn.getAttribute('data-src'));

    console.log('[CIG] open buttons:', openBtns.length);

    if (!modal || !imgEl || openBtns.length === 0) {
      console.warn('[CIG] missing modal or buttons – abort section');
      return;
    }

    const closeEls = Array.from(section.querySelectorAll('[data-cig-close]'));
    const prevBtn = section.querySelector('[data-cig-prev]');
    const nextBtn = section.querySelector('[data-cig-next]');

    // Build ordered source list
    const sources = [];
    openBtns.forEach((btn, domIndex) => {
      const raw = btn.getAttribute('data-index');
      const idx = Number.isFinite(parseInt(raw, 10)) ? parseInt(raw, 10) : domIndex;
      sources[idx] = btn.getAttribute('data-src');
    });

    const valid = sources
      .map((src, i) => (src ? i : null))
      .filter(i => i !== null);

    console.log('[CIG] images:', valid.length);

    if (!valid.length) return;

    let currentPos = 0;

    const showPos = (pos) => {
      currentPos = (pos + valid.length) % valid.length;
      imgEl.src = sources[valid[currentPos]];
      console.log('[CIG] show image', currentPos);
    };

    const open = (index) => {
      console.log('[CIG] open index', index);
      const pos = valid.indexOf(index);
      showPos(pos >= 0 ? pos : 0);
      modal.hidden = false;
      document.documentElement.style.overflow = 'hidden';
    };

    const close = () => {
      console.log('[CIG] close');
      modal.hidden = true;
      imgEl.src = '';
      document.documentElement.style.overflow = '';
    };

    const prev = () => showPos(currentPos - 1);
    const next = () => showPos(currentPos + 1);

    // CLICK BINDINGS
    openBtns.forEach((btn, domIndex) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        const raw = btn.getAttribute('data-index');
        const idx = Number.isFinite(parseInt(raw, 10)) ? parseInt(raw, 10) : domIndex;
        open(idx);
      });
    });

    closeEls.forEach(el => el.addEventListener('click', close));
    prevBtn && prevBtn.addEventListener('click', prev);
    nextBtn && nextBtn.addEventListener('click', next);

    // KEYBOARD
    window.addEventListener('keydown', (e) => {
      if (modal.hidden) return;
      if (e.key === 'Escape') close();
      if (e.key === 'ArrowLeft') prev();
      if (e.key === 'ArrowRight') next();
    });
  });
});
